module.exports = __webpack_public_path__ + "static/logo-78d34309c42e33d5db52244910eaed20.jpg";